"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = (config, instance) => {
  const lpbPrefix = config.apiPrefixes.lpb;
  return {
    getData() {
      const endpoint = lpbPrefix.startsWith('/shared') ? '/site-map' : '/sitemap';
      return instance.get(endpoint, {
        baseURL: lpbPrefix
      });
    }
  };
};
exports.default = _default;